<template>
  <div>
    <v-card
            v-show="showSearchPanel"
            class="search-bar"
    >
      <v-sheet class="d-flex justify-space-between  pa-1">
        <v-btn class="mr-2" text icon large @click="showSearchPanel = !showSearchPanel">
          <v-icon class="v-icon--left">mdi-arrow-left</v-icon>
        </v-btn>
        <v-text-field
                class="pa-0"
                v-model="search"
                label="Search something"
                flat
                solo
                hide-details
                clearable
                clear-icon="mdi-close-circle-outline"
        ></v-text-field>
      </v-sheet>
      <v-divider></v-divider>
      <v-card-text>
        <v-treeview
                v-model="selectedNodes"
                activatable
                selection-type="leaf"
                open-on-click
                selectable
                return-object
                :search="search"
                :open.sync="open"
                :items="treeview"
        >
          <template slot="label" slot-scope="{ item }">
            <div :style="{ cursor: 'pointer'}" @click="selectNode(item)">{{ item.name }}</div>
          </template>
        </v-treeview>
        <v-divider></v-divider>
        <div class="ma-1">Roadmaps:</div>
        <v-checkbox
                class="ma-1"
                v-for="roadmap in roadmaps"
                v-model="selectedRoadmaps"
                :key="roadmap.id"
                :label="roadmap.name"
                :value="roadmap"
                hide-details
        />
      </v-card-text>
    </v-card>
    <v-btn
            class="v-btn--fixed"
            v-if="!showSearchPanel" icon large
            @click="showSearchPanel = !showSearchPanel"
    >
      <v-icon>mdi-format-list-bulleted-square</v-icon>
    </v-btn>
    <help-dialog/>
    <node-dialog
            :node="nodeDialog"
            :close-dialog="closeDialog"
    />
    <div
            id="network-container"
            class="network-container">
      <d3-network
              ref='net'
              :net-nodes="nodes"
              :net-links="links"
              :options="options"
              @node-click="showDialog"
      />
    </div>
  </div>
</template>

<script>
  import D3Network from '../components/d3-net/vue-d3-network';
  import NodeDialog from "@/components/NodeDialog";
  import HelpDialog from "@/components/HelpDialog";

  export default {
    name: "NetworkVis",
    components: {
      HelpDialog,
      NodeDialog,
      D3Network,
    },
    data() {
      return {
        nodeDialog: undefined,
        nodes: [],
        links: [],
        picked: [],
        allNodes: [],
        allLinks: [],
        treeview: [],
        selectedNodes: [],
        roadmaps: [],
        selectedRoadmaps: [],
        /*TODO constants move to config */
        force: 1500,
        nodeSize: 20,
        canvas: false,
        size: {
          width: 1500,
          height: 1500,
        },

        color: {
          'concept': '#3cb44b',
          'roadmap': '#e6194B',
          'group': '#4363d8',
        },
        // colors: [
        //   '#e6194B',
        //   '#3cb44b',
        //   '#42d4f4',
        //   '#469990',
        //   '#ffe119',
        //   '#911eb4',
        //   '#f58231',
        //   '#4363d8'
        // ],
        search: '',
        showSearchPanel: true,
        open: [],
        resizerBlocked: false,
        resizerEvent: undefined,
      }
    },
    methods: {
      //   visibilityNodesHandler(event, node) {
      //     const filteredLinks = this.filteredLinks.filter(link => link.sid === node.id);
      //
      //     if (filteredLinks.length) {
      //       this.collapseNode(node);
      //     } else {
      //       this.expandNode(node);
      //     }
      //   },
      //   collapseNode(node) {
      //     const filteredLinks = this.filteredLinks.filter(link => link.sid === node.id);
      //     filteredLinks.forEach((l) => {
      //       this.recursiveRemoveNode(l.tid);
      //       this.filteredLinks.removeIf(item => {
      //         return item.sid === l.sid && item.tid === l.tid;
      //       });
      //     });
      //
      //     this.resizerBlocked = true;
      //     this.resizeNetworkContainer(
      //         1000 /*TODO constant move to config */,
      //         this.scrollToNode(node)
      //     );
      //   },
      //   expandNode(node) {
      //     let res = [];
      //     this.treeview.forEach((item) => {
      //       res.push(this.recursiveFindNode(item, node.id));
      //     });
      //
      //     // fix node in cur pos
      //     node.fx = node.x;
      //     node.fy = node.y;
      //
      //     const nodeChildren = res.filter(item => item !== null)[0].children;
      //
      //     this.buildSubGraph(nodeChildren, node, 0, () => {
      //       setTimeout(() => {
      //         // unfixed node after delay
      //         node.fx = null;
      //         node.fy = null;
      //       }, 1250 /*TODO constant move to config */);
      //
      //       this.resizerBlocked = true;
      //       this.resizeNetworkContainer(
      //           2000 /*TODO constant move to config */,
      //           this.scrollToNode(node)
      //       );
      //     })
      //   },
      //   // get structure of filteredNodes
      //   buildSubGraph(structure, parentNode, ms, cb) {
      //     let filteredNodes = [];
      //     let filteredLinks = [];
      //
      //     const size = structure.length;
      //
      //     const func = (i, size, ms) => {
      //       setTimeout(() => {
      //         if (i < size) {
      //           const res = this.recursiveAddNode(structure[i], parentNode);
      //           filteredNodes = filteredNodes.concat(res.filteredNodes);
      //           filteredLinks = filteredLinks.concat(res.filteredLinks);
      //
      //           func(i + 1, size, ms);
      //         } else {
      //           this.filteredNodes = this.filteredNodes.concat(filteredNodes);
      //           this.filteredLinks = this.filteredLinks.concat(filteredLinks);
      //
      //           cb();
      //         }
      //       }, i === 0 ? 0 : ms);
      //     };
      //
      //     func(0, size, ms);
      //   },
      //   recursiveFindNode(node, id) {
      //     const func = (node, id) => {
      //       if (node.id === id) {
      //         return node;
      //       }
      //
      //       if (node.children.length) {
      //         let res = [];
      //         node.children.forEach(child => {
      //           res.push(func(child, id));
      //         });
      //
      //         res = res.filter(item => item !== null);
      //
      //         return res.length ? res[0] : null;
      //       }
      //
      //       return null;
      //     };
      //
      //     return func(node, id);
      //   },
      //   recursiveAddNode(node, parentNode) {
      //     const func = (node, parentNode) => {
      //       let newNode = {
      //         _color: node.color,
      //         name: node.name,
      //         id: node.id
      //       };
      //
      //       if (parentNode) {
      //         // TODO why NaN start pos?
      //         newNode.x = parentNode.x;
      //         newNode.y = parentNode.y;
      //
      //         let newLink = {
      //           sid: parentNode.id,
      //           tid: node.id
      //         };
      //
      //         filteredLinks.push(newLink);
      //       } else {
      //         newNode._size = 32;
      //
      //         const winSize = this.getWindowSize();
      //
      //         newNode.x = winSize.w / 2;
      //         newNode.y = winSize.h / 2;
      //       }
      //
      //       filteredNodes.push(newNode);
      //
      //       if (node.children.length > 0) {
      //         if (parentNode) {
      //           newNode._size = 25;
      //         }
      //
      //         node.children.forEach((child) => {
      //           func(child, newNode);
      //         })
      //       }
      //     };
      //
      //     let filteredNodes = [];
      //     let filteredLinks = [];
      //     func.call(this, node, parentNode);
      //
      //     return {
      //       filteredNodes,
      //       filteredLinks
      //     };
      //   },
      //   recursiveRemoveNode(id) {
      //     const func = (id) => {
      //       const filteredLinks = this.filteredLinks.filter(link => link.sid === id);
      //       filteredLinks.forEach((l) => {
      //         func(l.tid);
      //         this.filteredLinks.removeIf(item => {
      //           return item.sid === l.sid && item.tid === l.tid;
      //         });
      //       });
      //
      //       this.filteredNodes.removeIf(item => {
      //         return item.id === id;
      //       });
      //     };
      //
      //     func.call(this, id);
      //   },
      resizeNetworkContainer(ms, callback) {
        setTimeout(() => {
          // TODO move to config
          const offsetH = 150;
          const offsetW = 300;

          const winSize = this.getWindowSize();
          const svgSize = this.getSvgBoxSize();

          if (this.size.width > svgSize.w + offsetW || this.size.width < svgSize.w - offsetW / 3) {
            this.size.width = winSize.w < svgSize.w + offsetW ? svgSize.w + offsetW : winSize.w;
          }

          if (this.size.height > svgSize.h + offsetH || this.size.height < svgSize.h - offsetH / 3) {
            this.size.height = winSize.h < svgSize.h + offsetH ? svgSize.h + offsetH : winSize.h;
          }

          this.resizerBlocked = false;

          callback();
        }, ms);
      },
      getWindowSize() {
        return {
          h: window.innerHeight
              || document.documentElement.clientHeight
              || document.body.clientHeight,
          w: window.innerWidth
              || document.documentElement.clientWidth
              || document.body.clientWidth,
        }
      },
      getSvgBoxSize() {
        const rect = document.getElementById('l-nodes').getBBox();
        return {
          h: rect.height,
          w: rect.width,
        }
      },
      scrollToSvgBoxCenter() {
        const winSize = this.getWindowSize();

        const container = document.getElementById('network-container');

        const scrollTop = this.size.height > winSize.h ? (this.size.height - winSize.h) / 2 : 0;
        const scrollLeft = this.size.width > winSize.w ? (this.size.width - winSize.w) / 2 : 0;

        // scroll left doest work
        window.scrollTo({
          top: scrollTop,
          behavior: "smooth"
        });

        // scroll top doest work
        container.scrollTo({
          left: scrollLeft,
          behavior: "smooth"
        })
      },
      scrollToNode(node) {
        return () => {
          const winSize = this.getWindowSize();
          const container = document.getElementById('network-container');
          const scrollTop = node.y > winSize.h / 2 ? node.y - winSize.h / 2 : 0;
          const scrollLeft = node.x > winSize.w / 2 ? node.x - winSize.w / 2 : 0;

          // scroll left doest work
          window.scrollTo({
            top: scrollTop,
            behavior: "smooth"
          });

          // scroll top doest work
          container.scrollTo({
            left: scrollLeft,
            behavior: "smooth"
          });

          const circle = document.getElementById(`node-${node.id}`);
          circle.classList.add('pulse-ring');

          setTimeout(() => {
            circle.classList.remove('pulse-ring');
          }, 1500);
        };
      },
      //   linkCallback(link) {
      //     link._svgAttrs = {
      //       'marker-end': 'url(#m-end)'
      //     };
      //     return link
      //   },
      selectNode(node) {
        node = this.nodes.find(n => n.id === node.id);

        if (node) {
          this.scrollToNode(node)(); // It's decorator
        }
      },
      closeDialog(event) {
        this.nodeDialog = undefined
      },
      showDialog(event, node) {
        if (this.nodeDialog && this.nodeDialog.id === node.id) {
          this.closeDialog()
        } else {
          this.nodeDialog = Object.assign({}, node)
        }
      }
    },
    watch: {
      filteredNodes(val) {
        // hack for deep copy
        this.nodes = JSON.parse((JSON.stringify(val)));
      },
      filteredLinks(val) {
        // hack for deep copy
        this.links = JSON.parse((JSON.stringify(val)));
      }
    },
    computed: {
      filteredNodes() {
        let filteredNodes = [];

        if (this.selectedRoadmaps.length > 0) {
          filteredNodes = this.selectedNodes.filter(item => {
            return this.selectedRoadmaps.some(roadmap => roadmap.concepts.includes(item.id));
          });
        } else {
          filteredNodes = this.selectedNodes;
        }

        filteredNodes = this.allNodes.filter(node => {
          return filteredNodes.findIndex(n => n.id === node.id) !== -1;
        });

        let parents = [];
        filteredNodes.forEach(node => {
          node.parents.forEach(parentId => {
            if (parents.findIndex(n => n.id === parentId) === -1) {
              parents.push(this.allNodes.find(n => n.id === parentId));
            }
          });
        });

        if (this.selectedRoadmaps.length > 0) {
          filteredNodes = filteredNodes.concat(this.selectedRoadmaps);
        }

        filteredNodes = filteredNodes.concat(parents);

        return filteredNodes;
      },
      filteredLinks() {
        return this.allLinks.filter(link => {
          const sidExist = this.filteredNodes.findIndex(node => node.id === link.sid) !== -1;
          const tidExist = this.filteredNodes.findIndex(node => node.id === link.tid) !== -1;
          return sidExist && tidExist;
        })
      },
      options() {
        return {
          force: this.force,
          size: {
            w: this.size.width,
            h: this.size.height
          },
          nodeSize: this.nodeSize,
          nodeLabels: true,
          linkLabels: false,
          canvas: this.canvas
        }
      },
    },
    mounted() {
      const repoPath = 'https://api.github.com/repos/roadmap-project/dev-learning-guidelines/contents';
      const dataPath = '/database/content/vis.json';

      fetch(repoPath + dataPath)
          .then(res => res.json())
          .then(data => {
            data = atob(data.content);
            data = JSON.parse(data);

            this.allLinks = data['links'];
            this.allNodes = data['nodes'];
            this.treeview = data['treeview'];
            this.roadmaps = data['roadmaps'];

            // TODO ref node pre processing
            this.allNodes.forEach(node => {
              node._size = node.is_concept ? this.nodeSize : this.nodeSize * 1.3;
              node._color = node.is_concept ? this.color.concept : this.color.group;
            });

            this.roadmaps.forEach(roadmap => {
              roadmap._size = this.nodeSize * 1.5;
              roadmap._color = this.color.roadmap;
              roadmap.is_roadmap = true;
            });

          });

      this.resizeNetworkContainer(0, this.scrollToSvgBoxCenter);

      this.resizerEvent = setInterval(() => {
        if (!this.resizerBlocked) {
          this.resizeNetworkContainer(0, () => {
          });
        }
      }, 1000);
    },
    beforeDestroy() {
      clearInterval(this.resizerEvent);
    }
  }
</script>

<style>
  /*#m-end path {*/
  /*  fill: rgba(18, 120, 98, 0.8);*/
  /*}*/

  .network-container {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
  }

  .dialog{
    width: auto;
    position: absolute;
  }

  .close{
    font-weight:bold;
    cursor: pointer;
  }

  .roadmap-header {
    width: 40%;
    min-width: 200px;
    margin: auto;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }

  .search-bar {
    position: fixed !important;
    width: 20%;
    min-width: 250px;
    max-height: 80%;
    overflow-y: auto;
  }

  .legend-item {
    padding: 5px;
    margin: 5px;
    text-align: center;
    border-radius: 4px;
  }

  .net {
    height: 100%;
    margin: 0
  }

  .node {
    stroke: #757575;
    stroke-opacity: 0.7;
    stroke-width: 2px;
    -webkit-transition: fill .5s ease;
    transition: fill .5s ease;
    fill: #dcfaf3
  }

  .node.selected {
    stroke: #caa455;
  }

  .link {
    stroke: #757575;
    stroke-opacity: 0.45;
  }

  .link, .node {
    stroke-linecap: round;
  }

  .node:hover {
    stroke: #757575;
    stroke-width: 3px;
  }

  .node.pinned {
    stroke: rgba(190, 56, 93, .7)
  }

  .node:hover {
    transform: translateY(-0.1em);
  }

  .link.selected {
    stroke: rgba(202, 164, 85, .6)
  }

  .curve {
    fill: none
  }

  .link-label, .node-label {
    fill: #424242;
    font-family: Verdana, serif;
    font-size: x-small;
    font-weight: bolder;
  }

  .link-label {
    -webkit-transform: translateY(-.5em);
    transform: translateY(-.5em);
    text-anchor: middle
  }

  .pulse-ring {
    animation: pulsate infinite 0.5s;
  }

  @-webkit-keyframes pulsate {
    0% {
      stroke: rgba(190, 56, 93, .6);
      stroke-width: 2px;
    }
    50% {
      stroke: rgba(190, 56, 93, 1);
      stroke-width: 10px;
    }
    100% {
      stroke: rgba(190, 56, 93, .6);
      stroke-width: 2px;
    }
  }
</style>
